/**
 * Created by Arif Topcu in 2019
 */

import React from "react";
import PropTypes from "prop-types";
import styles from "./FASelection.module.css";
import MiniFASelectorComplication from "./MiniFASelectorComplication";
import Icon from "react-icons-kit";
import { ic_add } from "react-icons-kit/md/ic_add";
import { ic_clear } from "react-icons-kit/md/ic_clear";
import Button from "@ls/react-button";
import PivotFADefinition from "state/pivots/PivotFADefinition";

const FaSelection = ({ definition, setNewFa, deleteFa }) => {
  const { faDefinitions } = definition;
  return (
    <div className={styles.root}>
      <div>
        {faDefinitions.map((faDefinition, idx) => {
          return (
            <div className={styles.betaDefinition} key={idx}>
              <div className={styles.closeButton}>
                <Button
                  icon={
                    <Icon
                      icon={ic_clear}
                      size={16}
                      style={{ color: "#464646" }}
                    />
                  }
                  size="S"
                  onButtonClick={() => deleteFa(idx)}
                  variation={5}
                />
              </div>
              <MiniFASelectorComplication
                setNewFa={(faDef) => setNewFa(idx, faDef)}
                faDefinition={faDefinition}
              />
            </div>
          );
        })}
      </div>
      <div
        className={styles.addMoreButton}
        onClick={() =>
          setNewFa(
            faDefinitions.length,
            new PivotFADefinition({
              factribFactor: "TOTAL",
              factribPeriod: "YTD",
            })
          )
        }
      >
        <Icon icon={ic_add} style={{ display: "flex", alignItems: "center" }} />
        <div>Add Factor Attribution</div>
      </div>
    </div>
  );
};

FaSelection.propTypes = {
  definition: PropTypes.object.isRequired,
  setNewFa: PropTypes.func.isRequired,
  deleteFa: PropTypes.func.isRequired,
};

export default FaSelection;
